import {useEffect} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';

const ReactScrollToTop = ({history, children}) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });

    return () => {
      unlisten();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children;
};

ReactScrollToTop.propTypes = {
  history: PropTypes.object,
  children: PropTypes.node,
};

export default withRouter(ReactScrollToTop);
